// Hierarchical query keys for the documents domain (TanStack).
// Always invalidate via this factory, never a hand-typed string literal:
// typos won't lint-fail but will silently break invalidation.
export const documentsKeys = {
  all: ['documents'] as const,
  subtypes: (companyId: string) => [...documentsKeys.all, 'subtypes', companyId] as const,
  aggregations: () => [...documentsKeys.all, 'aggregations'] as const,
  documentsAggregations: (
    companyId: string,
    category: string,
    isConfidential: boolean,
    query: Record<string, unknown>,
    subtype: string | null,
  ) => [...documentsKeys.aggregations(), companyId, category, isConfidential, query, subtype] as const,
  tagSuggestions: (companyId: string, prefix: string) =>
    [...documentsKeys.all, 'tagSuggestions', companyId, prefix] as const,
  searchFavorites: (companyId: string) => [...documentsKeys.all, 'searchFavorites', companyId] as const,
  dashboardStats: (companyId: string) => [...documentsKeys.all, 'dashboardStats', companyId] as const,
};
